import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import { AppLogo } from '../AppLogo';

const useStyles = makeStyles(theme => ({
  card: {
    display: 'flex',
    flexDirection: 'column',
    paddingTop: theme.spacing(3),
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingBottom: theme.spacing(6),
  },
  buttonWrapper: {
    display: 'flex',
    justifyContent: 'center',
  },
  appLogo: {
    paddingBottom: theme.spacing(3),
  },
}));

export const InstalledAppCard = ({ description, children, appLogo }) => {
  const classes = useStyles();
  return (
    <Grid item xs={12} sm={6}>
      <div className={classes.card}>
        <div className={classes.appLogo}>
          <AppLogo logo={appLogo} />
        </div>
        <Typography variant="body2" paragraph component="p">
          {description}
        </Typography>
        <div className={classes.buttonWrapper}>{children}</div>
      </div>
    </Grid>
  );
};

export default InstalledAppCard;

InstalledAppCard.defaultProps = {
  children: (
    <Button variant="contained" href="/" color="primary" target="_blank">
      OPEN
    </Button>
  ),
};

InstalledAppCard.propTypes = {
  description: PropTypes.string.isRequired,
  children: PropTypes.element,
  appLogo: PropTypes.node.isRequired,
};
